function escapeHtml(value) {
  const div = document.createElement('div');
  div.textContent = value == null ? '' : String(value);
  return div.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function formatMoney(price, format) {
  const cents = Math.round(parseFloat(price) * 100);
  if (Number.isNaN(cents)) return String(price);
  const value = (cents / 100).toFixed(2);
  const [whole, decimals] = value.split('.');
  const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return (format || '{{amount}}')
    .replace('{{amount}}', `${withCommas}.${decimals}`)
    .replace('{{amount_no_decimals}}', withCommas)
    .replace('{{amount_with_comma_separator}}', `${withCommas}.${decimals}`)
    .replace('{{amount_no_decimals_with_comma_separator}}', withCommas);
}

function renderProduct(product) {
  const image = product.featured_image ? product.featured_image.url : product.image;
  const alt = product.featured_image ? product.featured_image.alt || '' : '';
  const price = formatMoney(product.price, window.themeStrings.moneyFormat);
  return `
    <a href="${escapeHtml(product.url)}" class="product-card predictive-search__product">
      <div class="product-card__media">
        ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(alt)}" loading="lazy">` : ''}
      </div>
      <h3 class="product-card__title">${escapeHtml(product.title)}</h3>
      <p class="product-card__price">${escapeHtml(price)}</p>
    </a>
  `;
}

function renderLink(item) {
  return `<li><a href="${escapeHtml(item.url)}" class="predictive-search__link">${escapeHtml(item.title)}</a></li>`;
}

function renderResults(data, query, searchUrl) {
  const results = data.resources.results;
  const products = results.products || [];
  const pages = results.pages || [];
  const articles = results.articles || [];
  const hasResults = products.length > 0 || pages.length > 0 || articles.length > 0;

  if (!hasResults) {
    return `<p class="predictive-search__empty">${window.themeStrings.searchNoResults.replace('{{ terms }}', () => escapeHtml(query))}</p>`;
  }

  let html = '';

  if (products.length > 0) {
    html += `
      <div class="predictive-search__section">
        <div class="predictive-search__products">
          ${products.map(renderProduct).join('')}
        </div>
      </div>
    `;
  }

  const otherItems = [...pages, ...articles];
  if (otherItems.length > 0) {
    html += `
      <div class="predictive-search__section">
        <ul class="predictive-search__links">
          ${otherItems.map(renderLink).join('')}
        </ul>
      </div>
    `;
  }

  html += `<a href="${escapeHtml(searchUrl)}?q=${encodeURIComponent(query)}" class="predictive-search__view-all">${window.themeStrings.searchViewAll}</a>`;

  return html;
}

class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-predictive-search-input]');
    this.resultsEl = this.querySelector('[data-predictive-search-results]');
    this.searchUrl = this.dataset.searchUrl;
    this.debounceTimer = null;

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-predictive-search-toggle]');
      if (toggle) {
        event.preventDefault();
        this.lastToggle = toggle;
        this.open();
      }

      const closeBtn = event.target.closest('[data-predictive-search-close]');
      if (closeBtn) {
        this.close();
      }

      if (event.target.closest('[data-predictive-search-backdrop]')) {
        this.close();
      }
    });

    this.input.addEventListener('input', () => {
      clearTimeout(this.debounceTimer);
      const query = this.input.value.trim();

      if (query.length < 2) {
        this.resultsEl.hidden = true;
        this.resultsEl.innerHTML = '';
        return;
      }

      this.debounceTimer = setTimeout(() => this.fetchResults(query), 300);
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key === 'Tab' && !this.hidden) {
        const focusable = Array.from(this.querySelectorAll('a, button, input')).filter((el) => !el.hidden && !el.disabled);
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  async fetchResults(query) {
    this.currentQuery = query;

    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,page,article&resources[limit]=4&resources[options][unavailable_products]=hide`
      );
      const data = await response.json();

      if (this.currentQuery !== query) return;

      this.resultsEl.innerHTML = renderResults(data, query, this.searchUrl);
      this.resultsEl.hidden = false;
    } catch (error) {
      if (this.currentQuery !== query) return;
      this.resultsEl.innerHTML = '';
    }
  }

  open() {
    this.hidden = false;
    this.classList.add('is-open');
    this.input.focus();
    if (this.lastToggle) this.lastToggle.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.hidden = true;
    this.classList.remove('is-open');
    if (this.lastToggle) {
      this.lastToggle.setAttribute('aria-expanded', 'false');
      this.lastToggle.focus();
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);
